import { useState } from 'react';
export function useIsVisible(defaultValue) {
    const [isVisible, setIsVisible] = useState(defaultValue);
    const toggle = () => {
        setIsVisible(prev => !prev);
    };
    return {
        toggle,
        isVisible,
        setIsVisible,
    };
}
